
import './App.scss';
import {useState,useEffect} from 'react';
import {Switch, Route, Link,useParams } from 'react-router-dom';



function App() {

  const [currPlData,changeCurrPlData] = useState({
    "name": "",
    "url": "",
    "ranking": "0",
    "schedule": []
});
  const [searchString,changeSearchString] = useState("");
  const [data,changeScheduleData] = useState([]);
  const [stillLoading,changeStillLoading] = useState(true);
 

   

    const editInput = (e) =>
    {
        changeSearchString(e.target.value);
    };

    useEffect(()=>{
  
      getFullSchedule().then(res=>{changeScheduleData(res);
      changeStillLoading(false);
   }
      );
    
  },[]);

    async function getFullSchedule()
{
    
    const url = `https://www.dartsrankings.com/tennis/dataschedule`;
    const schedule = await(fetch(url,
    {
        method: 'GET',
        mode: 'cors', 
        cache: 'no-cache',
        credentials: 'same-origin', 

      }));
    
    return await schedule.json();
}

  return (

   !stillLoading && <section className="schedules">
      <div className="player-list">
          <input className="player-search" value={searchString} onChange={editInput} ></input>
          <div>
            <ul>
            {data.filter(pl=>pl.name.toLowerCase().includes(searchString.toLowerCase()) || pl.ranking.includes(searchString)).map((pl)=>{
              return(
                  <Link className={currPlData === pl ? "selected" : ""} to={"/"+pl.url}  key={pl.url} onClick={()=>changeCurrPlData(pl)}>
                    {pl.ranking} {pl.name}
                    </Link>
              );
            })
          }
          
        
          </ul>
      </div>
      </div>
      
      <PlayerSchedule currPlData={currPlData} loading={stillLoading}  />
      <Switch>
    
      <Route path="/:playerurl">
          <UpdateState changeCurrPlData = {changeCurrPlData} data={data} />
      </Route>
      </Switch>
    </section>
  );
}



function UpdateState({changeCurrPlData,data})
{
    const params = useParams();
    useEffect(
      ()=>{
        let newData = data.find(el=>el.url === params.playerurl);
        if (newData === undefined)
        {
          newData = data[0];
        }
        changeCurrPlData(newData)}
    ,[params,changeCurrPlData])
    

  return(
    <div>
          {
       
          }
    </div>
  );
}

function PlayerSchedule({currPlData}){
  return(
    <div className="player-schedule">
      <h2>{currPlData.name}</h2>
    
      {currPlData.schedule.length === 0 && currPlData.name && (<p>no tournament found</p>)}
        {currPlData.schedule.map((weekTnts)=>{
            
            const key = weekTnts[0].date + " " + currPlData.name;
          return(
              <div className="week" key={key} >
                
                <WeekTournaments tournaments={weekTnts}/>
                </div>
          )
        })}
    </div>
  )
}



function WeekTournaments({tournaments}){
  return(
    <table className="week-tournaments">
      <caption>{tournaments[0].date}</caption>
      <thead>
        <tr>
        <th>Tournament</th>
       <th>Type</th>
       <th>Main Draw</th>
       <th> Qualifying</th>
        </tr>
      </thead>
        <tbody>

        {tournaments.map((tnt)=>{

          return(
             
                <TournamentDetails tournament={tnt} key={tnt.name} />
             
          )
        })}
        </tbody>
    </table>
  )

}

function TournamentDetails({tournament})
{
  const possEntries = ["Direct Acceptance","SE","WC","ALT"];
 

  const accepted = (tournament.MainDraw && possEntries.some(el=> tournament.MainDraw.includes(el))) || (tournament.Qualifying && possEntries.some(el=> tournament.Qualifying.includes(el)));
  const classHere = (accepted ? "accepted" : "");
  return(
    
    <tr className={classHere}>
       <td>{tournament.name}</td>
       <td>{tournament.type}</td>
       <td>{tournament.MainDraw ? tournament.MainDraw.join(", ") : ""}</td>
       <td> {tournament.Qualifying ? tournament.Qualifying.join(", ") : ""}</td>
    </tr>
  )
}



export default App;
